<template>
    <div v-if="template.template_context === 'klaviyo'">
        <strong>Klaviyo Instructions</strong>

        <m-display-text
            label="URL"
            class="mt-4"
            :value="klaviyo_webhook_url"
        />

        JSON Body
        <m-code-block :click_anywhere_to_copy="false">
            {<br/>
                "red_chirp_template_subject_id" : "{{templateSubjectId}}",<br/>
                "first_name" : "<span v-pre>{{ person.first_name }}</span>",<br/>
                "last_name" : "<span v-pre>{{ person.last_name }}</span>",<br/>
                "email" : "<span v-pre>{{ person.email }}</span>",<br/>
                "phone_number" : "<span v-pre>{{ person.phone_number }}</span>"<br/>
            }<br/>
        </m-code-block>

        <p>
            For details on how to add a webhook to a flow in Klaviyo <a href="https://developers.klaviyo.com/en/docs/how-to-add-a-webhook-action-to-a-flow" target="_blank">click here</a>.
        </p>

        <p>
            <strong>Note:</strong> RedChirp will, to the best of its ability, automatically populate missing customer profile fields.
            For exampe, if a Klaviyo customer profile has email address but is missing a phone number, but you have a RedChirp contact that has the same email address, then that RedChirp contact will be automatically used to fill in the phone number.  If a contact has multiple phone numbers associated with it, and Klaviyo does not specify the phone number to text, then <strong>all</strong> phone numbers associated with the contact will be texted (provided they are SMS capable).
        </p>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        klaviyo_webhook_url: {
            type: String,
            required: true
        }
    },

    computed: {
        templateSubjectId() {
            return this.template.template_subject_id;
        }
    }
}
</script>
